import request from '@/utils/request' //引入封装好的 axios 请求

export function deleteProduct(productIds) {
  return request({
    url: '/product/deleteProduct',
    method: 'post',
    contentType: "application/json;charset=UTF-8",
    data:productIds
  })
}

export function deleteType (jo) { //删除接口
  return request({ //使用封装好的 axios 进行网络请求
    url: '/product/DeleteProductType',
    method: 'post',
    contentType: "application/json;charset=UTF-8",
    data: jo
  })
}